/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recent_ProjectsInputs */



/**
* | output |
* | --- |
* | "Recent Projects" |
*
* @param {Recent_ProjectsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const recent_projects = /** @type {((inputs?: Recent_ProjectsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recent_ProjectsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projets récents")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Projekte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetti recenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Недавние проекты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyectos recientes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("近期项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最近のプロジェクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हाल की परियोजनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projetos recentes")
	return /** @type {LocalizedString} */ ("Recent Projects")
});